import { render, staticRenderFns } from "./ChangeCustomerPhoto.vue?vue&type=template&id=9ebe8876&"
import script from "./ChangeCustomerPhoto.vue?vue&type=script&lang=js&"
export * from "./ChangeCustomerPhoto.vue?vue&type=script&lang=js&"
import style0 from "./ChangeCustomerPhoto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports